import React, {useCallback, useEffect, useState} from "react";
import { MenuItem } from "../../@types/stores/menu";
import { observer } from "mobx-react";
import "./style.scss";
import {getAllergenById, getHost} from "../../helpers/ApiHelper";
import defaultImg from "../../assets/images/default.webp";
import {OrderLine, OrderLineAddon, OrderLineAddons} from "../../@types/stores/order";
import lodash from "lodash";
import { useTranslation } from "react-i18next";
import AddonsGroup from "../MenuItem/AddonsGroup";
import orderStore from "../../stores/order";
import {useLocation, useNavigate, useParams} from "react-router";
import menuStore from "../../stores/menu";
import { moveToTop } from "../../helpers/DomHelper";
import useLayoutStyles from "../../hooks/styles";

export interface AddonsProps {
    item: MenuItem;
    addonGroupId?: number;
    skipRecommendations: boolean;
    isHalfAndHalf?: boolean;
}

const Addons = ({ item, addonGroupId, skipRecommendations, isHalfAndHalf }: AddonsProps) => {
    const params = useParams();
    const [t] = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const styles = useLayoutStyles();


    const [addons, setAddons] = useState<OrderLineAddons[]>([]);
    const [free, setFree] = useState<number>(item.freeAddons || 0);

    useEffect(() => {
        if (orderStore.currentOrderLine?.addons?.length && !addons.length)
            setAddons(orderStore.currentOrderLine.addons);
    }, [location]);

    useEffect(() => {
        if (addons.length) {
            const orderLine = orderStore.currentOrderLine;
            if (orderLine) {
                orderLine.addons = addons;
                orderStore.setCurrentOrderLine = orderLine;
                orderStore.reCalcCurrentOrderLine();
            }

            reCalcFreeAddons();
        }
    }, [addons]);

    const reCalcFreeAddons = () => {
        const count = addons.map(x => x.items).flat().length;
        const _free = item.freeAddons || 0;
        setFree(_free - count > 0 ? _free - count : 0);
    }

    const changeAddons = (id: number, selectedAddons: OrderLineAddon[]) => {
        const _addons = lodash.cloneDeep(addons).filter(x => x.groupId !== id);
        const addonGroup = item.addonGroups?.find(x => x.id === id);
        if (!addonGroup) return;

        _addons.push({
            groupId: id,
            groupFreeAddons: addonGroup.freeAddons || 0,
            items: selectedAddons
        });
        setAddons(_addons);
    }

    const goNext = () => {
        moveToTop();

        // Menu article
        if (!skipRecommendations) {
            if (addonGroupId) {
                if (item.addonGroups) {
                    const index = item.addonGroups.findIndex(x => x.id === addonGroupId);
                    if (index >= 0 && item.addonGroups.length - 1 > index) {
                        const nextGroupId = item.addonGroups.at(index + 1)?.id;

                        if (nextGroupId) {
                            navigate(`/menu/${menuStore.navigation.category}/${menuStore.navigation.subCategory}/${item.number}/addons/${nextGroupId}`);
                            return;
                        }
                    }
                    else if (item.ingredientGroups?.length) {
                        navigate(`/menu/${menuStore.navigation.category}/${menuStore.navigation.subCategory}/${item.number}/ingredients`);
                        return;
                    }
                }
            }
            else if (item.ingredientGroups?.length) {
                navigate(`/menu${isHalfAndHalf ? "/halfAndHalf" : ""}/${menuStore.navigation.category}/${menuStore.navigation.subCategory}/${item.number}/ingredients`);
                return;
            }
        }
        // Recommendation article
        else {
            if (typeof params.groupId !== "undefined") {
                const groupId = params.groupId && !isNaN(+params.groupId) ? +params.groupId : 0;
                if (groupId) {
                    if (addonGroupId) {
                        if (item.addonGroups) {
                            const index = item.addonGroups.findIndex(x => x.id === addonGroupId);
                            if (index >= 0 && item.addonGroups.length - 1 > index) {
                                const nextGroupId = item.addonGroups.at(index + 1)?.id;

                                if (nextGroupId) {
                                    navigate(`/recommendations/${groupId}/${item.number}/addons/${nextGroupId}`);
                                    return;
                                }
                            }
                            else if (item.ingredientGroups?.length) {
                                navigate(`/recommendations/${groupId}/${item.number}/ingredients`);
                                return;
                            }
                        }
                    }
                    else if (item.ingredientGroups?.length) {
                        navigate(`/recommendations/${groupId}/${item.number}/ingredients`);
                        return;
                    }
                }
            }
        }

        if (orderStore.currentOrderLine) {
            if (isHalfAndHalf) {
                if (menuStore.selectedHalfAndHalfStep >= 0) {
                    orderStore.currentOrderLine.count = 0.5;

                    const newArr: OrderLine[] = [...menuStore.selectedHalfAndHalfItems] as OrderLine[];
                    newArr[menuStore.selectedHalfAndHalfStep] = orderStore.currentOrderLine;
                    menuStore.selectedHalfAndHalfItems = newArr;

                    orderStore.currentOrderLine = null;
                }

                navigate(`/menu/halfAndHalf/${menuStore.halfAndHalfNavigation.category}/${menuStore.halfAndHalfNavigation.subCategory}`);
                return;
            }

            orderStore.addToOrder(orderStore.currentOrderLine);
        }

        if (menuStore.returnToScanArticle) {
            navigate("/scanArticle");

            return;
        }

        // from recommendations
        if (skipRecommendations) {
            if (menuStore.navigation.item) {
                const item = menuStore.getItemById(menuStore.navigation.item);

                if (item?.recommendedGroups?.length) {
                    const nextGroupIdIndex = item.recommendedGroups.findIndex(x => x === menuStore.navigation.recommendationGroupId) + 1;
                    if (nextGroupIdIndex && nextGroupIdIndex < item.recommendedGroups.length) {
                        const nextGroupId = item.recommendedGroups.at(nextGroupIdIndex);
                        navigate(`/recommendations/${nextGroupId}`);
                        return;
                    }
                }
            }

            navigate("/menu");
            return;
        }

        navigate("/recommendations");
    }

    const getSelectedAddons = useCallback((id: number) => {
        return addons.find(x => x.groupId === id)?.items || [];
    }, [addons]);

    if (!item)
        return null;

    return <div className="Addons">
        <h2>{item.name}</h2>
        <div className="img" style={{ backgroundImage: `url(${item.previewEdit ? `${getHost()}${item.previewEdit}` : (styles?.article.defaultEditImage ? `${getHost()}${styles.article.defaultEditImage}` : defaultImg)}` }} />
        <div className="description">{item.description || ""}</div>
        <div className="allergens">
            {item.allergens?.map(allergenId => getAllergenById(allergenId)?.name || null).filter(name => !!name).map(name => <div key={name} className="allergen">{name}</div>)}
        </div>
        <div className="addons">
            {addonGroupId
                ? item.addonGroups?.filter(ag => ag.id === addonGroupId).map(ag => <AddonsGroup key={`addonsGroup_${ag.id}`} addonsGroup={ag} onChange={changeAddons} selected={getSelectedAddons(ag.id)} free={free} />)
                : (item.addonGroups?.length
                    ? item.addonGroups.map(ag => <AddonsGroup key={`addonsGroup_${ag.id}`} addonsGroup={ag} onChange={changeAddons} selected={getSelectedAddons(ag.id)} free={free} />)
                    : null)
            }
        </div>
        <div className={`button dark`} onClick={goNext}>{t(addons.map(mg => mg.items).flat().length ? `next` : `skip`)}</div>
    </div>
}

export default observer(Addons);
